import {X} from 'lucide-react';
import * as React from 'react';
import {Button} from 'src/Button';

type Props = {
  onReset: () => void;
};

/**
 * Clears every filter on a list in one click. Rendered only while something
 * is actually filtered — an always-present control that does nothing most of
 * the time reads as broken, and the pill row is tight enough on a phone that
 * an inert button costs a real filter its place on screen.
 *
 * Styled as a trailing pill-row item rather than a normal button: it lives
 * among the filter pills it clears, and matching their height keeps the row
 * one pill tall.
 */
export const ResetFiltersButton = ({onReset}: Props) => (
  <Button
    variant="ghost"
    className="text-muted-foreground h-auto shrink-0 gap-1 rounded-full px-2 py-1 text-sm font-normal"
    onClick={onReset}
  >
    <X size={14} />
    Reset filters
  </Button>
);
